<template>
    <div class="c-tooltip-button" :class="computedClass" :style="{top: top+'px',  left: left+'px'}">
        <div class="c-tooltip-button__wrap">
            <button class="c-tooltip-button__button" @click="clickEvent">
                <span class="c-tooltip-button__decoration">{{text}}</span>
            </button>
        </div>
    </div>
</template>

<script>
const positions = ["left-bottom", "right-bottom"];

import cTooltip from "./tooltip";

export default {
  name: "cTooltipButton",
  extends: cTooltip,
  props: {
    position: {
      required: true,
      validator: function(value) {
        return positions.indexOf(value) !== -1;
      }
    },
    top: {
      default: 0
    },
    left: {
      default: 0
    },
    text: {
      required: true
    },
    clickEvent: {
      type: Function,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
  },
  computed: {
    computedClass() {
      return {
        "c-tooltip-button--bottom-left": this.position === positions[0],
        "c-tooltip-button--bottom-right": this.position === positions[1]
      };
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.c-tooltip-button {
  position: absolute;
  max-width: 160px;
  z-index: 30;
  $blockname: &;
  &__wrap {
    background: $tooltip_background_blue;
    position: relative;
    text-align: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  }
  &__button {
    padding: 10px 15px;
    color: #ffffff;
    font-size: 14px;
    display: inline-block;
    background: $tooltip_background_blue;
    border: none;
    &:hover {
      cursor: pointer;
    }
  }
  &__decoration {
    border-bottom: 1px dashed #ffffff;
    font-size: 14px;
    display: inline-block;
  }

  &--bottom-left {
    #{$blockname}__wrap {
      &:before {
        border: 7px solid transparent;
        border-bottom: 7px solid $tooltip_background_blue;
        border-left: 7px solid $tooltip_background_blue;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        transform: translateY(-100%);
      }
    }
  }
  &--bottom-right {
    #{$blockname}__wrap {
      &:before {
        border: 7px solid transparent;
        border-bottom: 7px solid $tooltip_background_blue;
        border-right: 7px solid $tooltip_background_blue;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        transform: translateY(-100%);
      }
    }
  }
}
</style>
